<template>
  <CSIcon :name="iconName" :color="iconColor" size="20px" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import CSIcon from "./CharitySystem/CSIcon.vue";
const props = defineProps({ isPositive: { type: Boolean, required: true } });

const iconName = computed(() =>
  props.isPositive ? "fa-solid fa-circle-check" : "fa-solid fa-circle-xmark"
);

const iconColor = computed(() => (props.isPositive ? "positive" : "negative"));
</script>
